import type { InputComboboxProps, Option } from '../InputCombobox';

export function filterComboboxOptions<T>(
  options: Option<T>[] | undefined,
  query: string,
): Option<T>[] {
  if (!options) return [];

  const normalizedQuery = query.toLowerCase();
  return options.filter((option) =>
    option.label.toLowerCase().includes(normalizedQuery),
  );
}

export function resolveComboboxDefaultValue<T>(
  defaultValue: T | T[] | undefined,
  isMultiple: boolean,
): T | T[] | '' {
  if (!isMultiple) return defaultValue ?? '';
  if (Array.isArray(defaultValue)) return defaultValue;
  if (defaultValue === undefined) return [];

  return [defaultValue];
}

export function getComboboxChoiceLimit<T>(
  props: InputComboboxProps<T>,
): number | undefined {
  return props.multiple ? props.choiceLimit : undefined;
}
